import { makeStyles } from '@material-ui/core/styles';

const FeedbackFormStyle = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'flex-start',  // Changed from 'center' to 'flex-start'
    justifyContent: 'center',
    paddingTop: '10vh',  // Added to position the modal 10% from the top
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: 'none',
    maxWidth: 600,
    width: '90%',
    maxHeight: '80vh',  // Adjusted to account for the top padding
    overflowY: 'auto',
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  closeButton: {
    marginTop: theme.spacing(3),
  },
}));

export default FeedbackFormStyle;